import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../images/services-usa/iot-new/power_iot.webp";

function Streamlinecloud() {
  return (
    <section
      className="streamline_cloud blockchain_future"
      style={{
        backgroundImage: `url(${BgImg})`,
      }}
    >
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="offset-md-6">
            <h2>
              Discover the Power of IoT to <span>Build Smart Solutions!</span>
            </h2>
            <p>
              Realize the IoT opportunity and enhance your business processes
              with unique smart solutions by IoT professionals. Foster ideas and
              improvements with our specialists to enhance your operational flow
              without a hitch.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Talk to Our IoT Experts
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Streamlinecloud;
